import { CanMakeHouseholdChangesSelector, CurrentHouseholdSelector, CurrentMemberIsHeadOfHouseholdSelector, EnableHouseholdAccessPrivilegesSelector, EnableHouseholdUsagePrivilegesSelector, HeadOfHouseholdIsSelectedSelector, HouseholdErrorSelector, HouseholdMemberMoreOptionsSelector, IsRemovingHouseholdMemberSelector, RatingsByCategorySelector, SelectedHouseholdMemberSelector, SelectedHouseholdMemberServicesSelector, SelectedMemberPaymentPrivilegesViewModelsSelector, SelectedMemberPrivilegesSelector, SelectedMemberIsCurrentMemberSelector } from '../../../../reducers/selectors/customer.household.selectors';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { findLastSelectedRating } from '../../household/household.helpers';
import { removeHouseholdMembers, retrieveCustomerHouseholds, updateHouseholdMember } from '../../../../reducers/actions/customer.household.actions';
import { i18n, BusinessUnitSelectors, MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { CustomerActionsTemplateSelector } from '../../../../reducers/selectors/customer.actions.template.selectors';
import { ACTIVATE_MEMBER_OPTION_ID, EDIT_PRIVILEGES_ID, REMOVE_MEMBER_OPTION_ID } from '../household.constants';
import { retrieveWallet } from '../../../../reducers/actions/customer.ewallet.actions';
import { IsRetrievingEwalletDataSelector, PaymentInstrumentsWithTypeNamesViewModel } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { retrieveConvergentBillerSubscriberSummary } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { ConvergentBillerSubscriberSummaryServicesSelector, IsFetchingSubscriberSummarySelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
function MemberDetailsController($ngRedux, uiNotificationService, $state) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    var selectedMemberServices = SelectedHouseholdMemberServicesSelector(store);
    return {
      canMakeChanges: CanMakeHouseholdChangesSelector(store),
      currentCustomerId: CurrentCustomerIdSelector(store),
      currentHousehold: CurrentHouseholdSelector(store),
      currentMemberIsHeadOfHousehold: CurrentMemberIsHeadOfHouseholdSelector(store),
      customerActionsTemplate: CustomerActionsTemplateSelector(store),
      enableHouseholdAccessPrivileges: EnableHouseholdAccessPrivilegesSelector(store),
      enableHouseholdUsagePrivileges: EnableHouseholdUsagePrivilegesSelector(store),
      hasLoadedHouseholdPrivileges: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.HouseholdPrivileges, store),
      hasLoadedRatings: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.Rating, store),
      hasLoadedRatingCategories: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.RatingCategory, store),
      hasLoadedTimezones: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TimeZone, store),
      timezones: MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.TimeZone, store),
      headOfHouseholdSelected: HeadOfHouseholdIsSelectedSelector(store),
      householdMemberMoreOptions: HouseholdMemberMoreOptionsSelector(store),
      isDbss: BusinessUnitSelectors.IsDbss(store),
      isFetchingSubscriberSummary: IsFetchingSubscriberSummarySelector(store),
      isRemovingHouseholdMember: IsRemovingHouseholdMemberSelector(store),
      isRetrievingWallet: IsRetrievingEwalletDataSelector(store),
      lastAttemptError: HouseholdErrorSelector(store),
      paymentInstruments: PaymentInstrumentsWithTypeNamesViewModel(store),
      privileges: SelectedMemberPrivilegesSelector(store),
      ratingsByCategory: RatingsByCategorySelector(store),
      selectedMemberPaymentInstruments: SelectedMemberPaymentPrivilegesViewModelsSelector(store),
      selectedMember: SelectedHouseholdMemberSelector(store),
      selectedMemberServices: selectedMemberServices,
      hasServicesForMember: selectedMemberServices && selectedMemberServices.length,
      selectedMemberIsCurrentMember: SelectedMemberIsCurrentMemberSelector(store),
      subscriberServices: ConvergentBillerSubscriberSummaryServicesSelector(store)
    };
  };
  var controllerActions = {
    fetchCodeType: MetadataActions.codes.fetchCodeTypes,
    removeHouseholdMembers: removeHouseholdMembers,
    retrieveCustomerHouseholds: retrieveCustomerHouseholds,
    retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
    retrieveWallet: retrieveWallet,
    updateHouseholdMember: updateHouseholdMember
  };
  this.$onInit = function () {
    _this.customerCareKeys = CustomerCareLocaleKeys;
    _this.valueLocaleKeys = {
      allowed: i18n.translate(_this.customerCareKeys.ALLOWED),
      headOfHousehold: i18n.translate(_this.customerCareKeys.HOUSEHOLD.HEAD_OF_HOUSEHOLD),
      member: i18n.translate(_this.customerCareKeys.HOUSEHOLD.MEMBER),
      no: i18n.translate(_this.customerCareKeys.NO),
      notAllowed: i18n.translate(_this.customerCareKeys.NOT_ALLOWED),
      yes: i18n.translate(_this.customerCareKeys.YES)
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.stateOrName = 'index.customercare.customer';
    _this.$state = $state;
    if (!_this.state.hasLoadedRatings) {
      _this.actions.fetchCodeType(MetadataConstants.codes.Rating);
    }
    if (!_this.state.hasLoadedRatingCategories) {
      _this.actions.fetchCodeType(MetadataConstants.codes.RatingCategory);
    }
    if (!_this.state.hasLoadedTimezones) {
      _this.actions.fetchCodeType(MetadataConstants.codes.TimeZone);
    }
    if (!_this.state.hasLoadedHouseholdPrivileges) {
      _this.actions.fetchCodeType(MetadataConstants.codes.HouseholdPrivileges);
    }
    if (!_this.state.subscriberServices && _this.state.isDbss) {
      _this.actions.retrieveConvergentBillerSubscriberSummary(_this.state.currentCustomerId);
    }
    if (!_this.state.paymentInstruments.length) {
      _this.actions.retrieveWallet({
        customerId: _this.state.currentHousehold.HeadOfHouseholdSubscriberId
      });
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.handleMoreOptionsMenuSelected = function (item) {
    switch (item.item.id) {
      case ACTIVATE_MEMBER_OPTION_ID:
        _this.activateHouseholdMember();
        break;
      case REMOVE_MEMBER_OPTION_ID:
        _this.removeMemberConfirmation.open();
        break;
      case EDIT_PRIVILEGES_ID:
        _this.$state.go('index.customercare.customer.household.memberprivileges', {
          subscriberId: _this.state.selectedMember.SubscriberId
        });
        break;
      default:
        break;
    }
  };
  this.showMoreButton = function () {
    return _this.state.canMakeChanges && !_this.state.headOfHouseholdSelected && _this.state.householdMemberMoreOptions.length;
  };
  this.removeMemberConfirmation = {
    onRegisterApi: function onRegisterApi(event) {
      Object.assign(_this.removeMemberConfirmation, event.api);
    },
    onResult: function onResult(proceed) {
      _this.removeMemberConfirmation.close();
      if (proceed) {
        removeCurrentHouseholdMember();
      }
    },
    onClose: function onClose() {
      _this.removeMemberConfirmation.close();
    }
  };
  this.householdErrorPopupConfig = {
    onRegisterApi: function onRegisterApi(event) {
      Object.assign(_this.householdErrorPopupConfig, event.api);
    },
    onResult: function onResult() {
      _this.householdErrorPopupConfig.close();
    },
    onClose: function onClose() {
      _this.householdErrorPopupConfig.close();
    }
  };
  var removeCurrentHouseholdMember = function removeCurrentHouseholdMember() {
    _this.actions.removeHouseholdMembers(_this.state.currentCustomerId, _this.state.currentHousehold.Id, [_this.state.selectedMember]).then(function () {
      _this.actions.retrieveCustomerHouseholds(_this.state.currentCustomerId, true);
      uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.HOUSEHOLD.REMOVE_HOUSEHOLD_MEMBER_SUCCESS_MESSAGE), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    }).catch(function () {
      _this.householdErrorPopupConfig.open();
    });
  };
  this.activateHouseholdMember = function () {
    var includeRemoved = true;
    _this.actions.updateHouseholdMember(_this.state.currentCustomerId, _this.state.currentHousehold.Id, _this.state.selectedMember).then(function () {
      _this.actions.retrieveCustomerHouseholds(_this.state.currentCustomerId, includeRemoved);
      uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.HOUSEHOLD.REACTIVATE_HOUSEHOLD_MEMBER_SUCCESS_MESSAGE), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    }).catch(function () {
      uiNotificationService.success(_this.state.lastAttemptError, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
  this.getYesNo = function (value) {
    return _this.valueLocaleKeys[value ? 'yes' : 'no'];
  };
  this.getAllowedNotAllowed = function (value) {
    return _this.valueLocaleKeys[value ? 'allowed' : 'notAllowed'];
  };
  this.getRole = function (headOfHouseholdSelected) {
    return _this.valueLocaleKeys[headOfHouseholdSelected ? 'headOfHousehold' : 'member'];
  };
  this.getSpendingLimitEveryFrequencyString = function (numberOfDays, daysUnitTxt) {
    return numberOfDays && daysUnitTxt ? " / ".concat(numberOfDays, " ").concat(daysUnitTxt) : '';
  };
  this.isLoading = function () {
    return _this.state.isRemovingHouseholdMember || _this.state.isFetchingSubscriberSummary || _this.state.isRetrievingWallet;
  };
  this.getRoleWithAccessPrivilegeInformation = function () {
    return _this.state.privileges.MemberManagementEnabled ? "".concat(_this.getRole(_this.state.headOfHouseholdSelected), " (").concat(i18n.translate(_this.customerCareKeys.HOUSEHOLD.FULL_ACCESS_PRIVILEGES), ")") : _this.state.privileges.ManageServicesEnabled ? "".concat(_this.getRole(_this.state.headOfHouseholdSelected), " (").concat(i18n.translate(_this.customerCareKeys.HOUSEHOLD.SERVICE_LEVEL_PRIVILEGES), ")") : _this.getRole(_this.state.headOfHouseholdSelected);
  };
  this.isCurrentMemberSelectedOrHeadOfHousehold = function () {
    return _this.state.currentMemberIsHeadOfHousehold || _this.state.selectedMemberIsCurrentMember;
  };
  this.canViewBalanceDetails = function () {
    return _this.isCurrentMemberSelectedOrHeadOfHousehold() && _this.state.privileges.EnforcePaymentPrivileges && _this.state.privileges.LimitSpending;
  };
  this.canViewSharedPaymentMethods = function () {
    return _this.isCurrentMemberSelectedOrHeadOfHousehold() && _this.state.privileges.EnforcePaymentPrivileges && _this.state.selectedMemberPaymentInstruments.length > 0;
  };
  this.hasAccessPrivilegesEnforced = function () {
    return _this.isCurrentMemberSelectedOrHeadOfHousehold() && _this.state.privileges.EnforceAccessPrivileges;
  };
  this.hasAccessPrivilegesSet = function () {
    if (_this.state.privileges.RatingPrivileges) {
      return _this.state.privileges.RatingPrivileges.length > 0;
    }
  };
  this.hasUsagePrivilegesEnforced = function () {
    return _this.isCurrentMemberSelectedOrHeadOfHousehold() && _this.state.privileges.EnforceUsagePrivileges;
  };
  this.hasUsagePrivilegesSet = function () {
    return _this.state.privileges.DayAndTimePrivileges.length > 0;
  };
  this.canViewServiceIDs = function () {
    return _this.isCurrentMemberSelectedOrHeadOfHousehold() && _this.state.isDbss;
  };
  this.findLastSelectedRatingName = function (ratings, memberRatings) {
    var lastRating = findLastSelectedRating(ratings, memberRatings);
    return lastRating ? lastRating.Name : null;
  };
  this.getTimezoneDisplayName = function () {
    var timezoneValue = _this.state.privileges.Timezone;
    if (!timezoneValue || !_this.state.timezones.items) {
      return null;
    }
    var timezone = _this.state.timezones.items.find(function (_ref) {
      var Value = _ref.Value;
      return parseInt(Value) === parseInt(timezoneValue);
    });
    return timezone ? timezone.Name : null;
  };
}
export default {
  template: require('./member.details.html'),
  controllerAs: 'MemberDetails',
  controller: MemberDetailsController
};